import { tooltipClasses, Theme } from '@mui/material';
import { TooltipMode } from './interfaces';

export function isInfoTooltip(mode: TooltipMode | undefined) {
  return mode === 'info';
}

export function isSecondaryTooltip(mode: TooltipMode | undefined) {
  return mode === 'secondary';
}

export function isSurfaceTooltip(mode: TooltipMode | undefined) {
  return mode === 'surface';
}

export function tooltipPlacementMargin(extraOffsetX?: number, extraOffsetY?: number) {
  return {
    ...(extraOffsetX
      ? {
          [`& .${tooltipClasses.tooltipPlacementRight}`]: {
            marginLeft: `${extraOffsetX}px !important`
          },
          [`& .${tooltipClasses.tooltipPlacementLeft}`]: {
            marginRight: `${extraOffsetX}px !important`
          }
        }
      : {}),
    ...(extraOffsetY
      ? {
          [`& .${tooltipClasses.tooltipPlacementTop}`]: {
            marginBottom: `${extraOffsetY}px !important`
          },
          [`& .${tooltipClasses.tooltipPlacementBottom}`]: {
            marginTop: `${extraOffsetY}px !important`
          }
        }
      : {})
  };
}

export function getTooltipBorderStyle(mode: TooltipMode | undefined) {
  if (!mode) {
    return '';
  }

  if (isInfoTooltip(mode)) {
    return 'solid 1px var(--info-border-color)';
  }

  if (isSecondaryTooltip(mode)) {
    return 'solid 1px var(--divider-color)';
  }

  return '';
}

export function getTooltipBoxShadow(mode: TooltipMode | undefined) {
  if (!mode) {
    return 'var(--shadow-tooltip)';
  }

  if (isSecondaryTooltip(mode)) {
    return 'none';
  }

  if (isSurfaceTooltip(mode)) {
    return 'var(--shadow-dropdown)';
  }

  return 'var(--shadow-tooltip)';
}

export function getTooltipColor(theme: Theme, mode: TooltipMode | undefined): string {
  if (!mode) {
    return theme.palette.common.black;
  }

  if (isSurfaceTooltip(mode)) {
    return 'var(--surface-tooltip-bg-color)';
  }

  if (isSecondaryTooltip(mode)) {
    return 'var(--surface-bg-overlay-color)';
  }

  if (isInfoTooltip(mode)) {
    return 'var(--primary-faded-color)';
  }

  return theme.palette.common.black;
}
